import React, { useEffect, useState } from "react";
import { dateFormatInverseShort, hourFormat } from "functions/functions";
import "./footerCardEventSlider.sass";

export default function FooterCardEventSlider({ urlmomioEvento, statusEvent, classEvent, dateUTC, flagMomios, urlEvento, vueltas, sport, classPatrocinador }) {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 780);

    const updateMobileStatus = () => {
        setIsMobile(window.innerWidth <= 780);
    };

    useEffect(() => {
        window.addEventListener('resize', updateMobileStatus);

        return () => {
            window.removeEventListener('resize', updateMobileStatus);
        };
    }, []);

    return (
        <div className={
            (
                (flagMomios === 'true' || flagMomios === true) // && 
                //(classEvent != "clarosports-finished-game" && classEvent != "clarosports-error-game" )
            ) 
        ? 'footer-card-evento-slider footer-card-cm' : "footer-card-evento-slider footer-card-sm"}>

            {(flagMomios === 'true' || flagMomios === true) && // (classEvent != "clarosports-finished-game" && classEvent != "clarosports-error-game") &&
                <a href={urlmomioEvento} className={"buttonJuegaAqui " + classPatrocinador} target="_blank" rel="noreferrer"><span>Juega Aquí</span></a>
            }

            {(isMobile || (classEvent === "clarosports-finished-game" || classEvent === "clarosports-error-game"))
                ? <div className={((flagMomios === 'true' || flagMomios === true) ||  (classEvent === "clarosports-finished-game" || classEvent === "clarosports-error-game" ) ) ? `statusGame ${classEvent} gameM`  : `statusGame ${classEvent} gameSM`}>
                    {classEvent === "clarosports-finished-game" || classEvent === "clarosports-error-game"
                        ? <p className="name-period">{String(statusEvent).toUpperCase()}</p>
                        : classEvent === "clarosports-in-progress-game"
                            ? <p className="name-period">EN VIVO {sport !== "MTR" && <span className={String(statusEvent).toLowerCase() === 'medio tiempo' ? "timeMiddle" : ''}>{statusEvent}</span>}
                            </p>
                            : classEvent === "clarosports-next-game"
                            && <p className="name-period">{dateFormatInverseShort(dateUTC)} {hourFormat(dateUTC)}</p>
                    }
                </div>
                : <a href={urlEvento} className={"statusGame " + classEvent} target="_top">
                    {classEvent === "clarosports-finished-game" || classEvent === "clarosports-error-game" 
                        ? <p className="name-period">{String(statusEvent).toUpperCase()}</p>
                        : classEvent === "clarosports-in-progress-game"
                            ? <p className="name-period">EN VIVO {sport !== "MTR" && <span className={String(statusEvent).toLowerCase() === 'medio tiempo' ? "timeMiddle" : ''}> {statusEvent}</span>}</p>
                            : classEvent === "clarosports-next-game"
                            && <p className="name-period">{dateFormatInverseShort(dateUTC)} {hourFormat(dateUTC)}</p>
                    }
                </a>
            }
        </div>
    );
}
